import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CalendarsListStateService } from '@modules/calendar-app/services/calendars-list-state.service';
import { DateRangeCalendarEventsListStore } from '@modules/calendar-app/services/date-range-events-list.store';
import { EventsListStateService } from '@modules/calendar-app/services/events-list-state.service';
import { StateKey } from '@modules/settings/types/state-key';

@Component({
  standalone: true,
  selector: 'stch-date-range-calendar-events-store-provider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content />`,
  providers: [
    ...EventsListStateService.providers({
      stateKey: StateKey.eventsListState,
      withAdvancedSearch: true,
    }),
    ...CalendarsListStateService.providers({
      stateKey: StateKey.calendarsListState,
      withAdvancedSearch: true,
    }),
    DateRangeCalendarEventsListStore,
  ],
})
export class DateRangeCalendarEventsStoreProviderComponent {}
